
export function isTouchDevice() {
    return (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0));
}

export function getWindowWidth() {
    return document.body.getBoundingClientRect().width;
}

export function getDeviceType() {
    if (navigator.userAgent.includes("Android")) {
        return {
            'type' : 'device-mobile',
            'os' : 'device-android'
        };
    }

    if ( navigator.userAgent.includes("iPhone") || navigator.userAgent.includes("iPad") || navigator.userAgent.includes("iPod")) {
        return {
            'type' : 'device-mobile',
            'os' : 'device-ios'
        };
    }

    return {
        'type' : 'device-desktop',
        'os' : 'device-desktop'
    };
}

export function deviceBodyClass() {
    let timerId;

    function set_body_class_for_device () {
        clearTimeout(timerId);
        timerId = setTimeout(function() {
            const device = get_device_type();
            if (document.body.etoroDeviceType === device.type) {
                return;
            }

            const body = document.body;
            body.classList.remove(body.etoroDeviceType, body.etoroDeviceOS);
            body.classList.add(device.type, device.os);
            body.etoroDeviceType = device.type;
            body.etoroDeviceOS = device.os;
        }, 500);
    }

    set_body_class_for_device();
    const resizeObserver = new ResizeObserver(set_body_class_for_device);
    resizeObserver.observe(document.body);
}

export function getCookie( name ) {
    const value = `; ${document.cookie}`;
    const parts = value.split( `; ${name}=` );
    if (parts.length === 2) {
        return parts.pop().split( ';' ).shift();
    }
}

export function setCookie(c_name, value, exdays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    let c_value = encodeURIComponent(value) +
      ((exdays == null) ? '' : '; expires=' + exdate.toUTCString());
    document.cookie = c_name + '=' + c_value + ';path=/';
}

export function deleteCookie(name) {
    setCookie(name, '', -1);
}

export const debounce = (func, delay) => {
    let inDebounce;

    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
};

export function getOffsetForElements() {
    const styles = getComputedStyle(document.body);
    const offsetForAnchors = parseInt(styles.getPropertyValue('--content-offset'), 10);
    return offsetForAnchors;
}